import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=17c2c76c&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=17c2c76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c2c76c",
  null
  
)

export default component.exports